import {
  getCommonOptionGaugeUmbral,
  initChart,
  formatearFecha,
  getTime,
  addPointInteger,
} from '../common';
import { createLeafletMapPolygon } from '../common-leafletMap';
import { IDIOMA } from '../constants/constants';
import TEXTS_BICIS from './textos';

const UMBRAL_AMARILLO_VERDE = 0.3;
const UMBRAL_ROJO_AMARILLO = 0.2;
const STYLE_MARKER = {
  weight: 5,
  color: '#ADB4B7',
  opacity: 1.0,
  fillColor: '#ADB4B7',
};
const STYLE_MARKER_SELECTED = {
  weight: 5,
  color: '#9D8BB8',
  opacity: 1.0,
  fillColor: '#9D8BB8',
};

/**
 * Dibuja el grafico de la intensidad actual de bicis
 * @param {*} dato Valor de intensidad del tramo en RealTime
 */
const dibujarGraficaUmbral = (dato) => {
  const options = getCommonOptionGaugeUmbral(
    dato,
    UMBRAL_ROJO_AMARILLO,
    UMBRAL_AMARILLO_VERDE,
    TEXTS_BICIS[IDIOMA].get('graficaUmbral'),
  );
  initChart('graficaRT', options);
};

/**
 * Genera un Identificador de cada Tramo Direccion + _fXX
 * @param {String} datos String que indica tipo de medida y tramo (EJ: bicis_rt_f7)
 * @param {String} direccion Direccion del tramo a mostrar
 */
function createIDTramo(typeMesure, address) {
  const regex = /_f\d{1,2}/;
  const matchResult = typeMesure.match(regex);

  return matchResult ? address + matchResult[0] : '';
}
/**
 * Setea la informacion del tramo en los elementos del DOM del HTML
 * @param {Array} datos Array con los datos de un tramo
 * @param {String} direccion Direccion del tramo a mostrar
 */
export function setDOMData(datos, direccion) {
  const containerTramo = document.querySelector('#textoNombreTramo');
  const containerHora = document.querySelector('#textoHoraActualizacion');
  const containerFecha = document.querySelector('#textoFechaActualizacion');

  const containerDataDia = document.querySelector('#dataDia');
  const containerDataMes = document.querySelector('#dataMes');
  const containerDataAnyo = document.querySelector('#dataAnyo');

  const dailyData = datos
    .filter((array) => array[1].includes('daily'))
    .map((array) => addPointInteger(Math.round(array[3])));
  const monthlyData = datos
    .filter((array) => array[1].includes('monthly'))
    .map((array) => addPointInteger(Math.round(array[3])));
  const annualData = datos
    .filter((array) => array[1].includes('annual'))
    .map((array) => addPointInteger(Math.round(array[3])));
  const rtData = datos
    .filter((array) => array[1].includes('rt'))
    .map((array) => ({
      intensidad: addPointInteger(Math.round(array[3])),
      fecha: array[5],
    }));

  containerTramo.textContent = direccion;
  containerDataDia.textContent = dailyData;
  containerDataMes.textContent = monthlyData;
  containerDataAnyo.textContent = annualData;

  dibujarGraficaUmbral(rtData[0].intensidad);
  containerHora.textContent = getTime(new Date(rtData[0].fecha));
  containerFecha.textContent = formatearFecha(new Date(rtData[0].fecha));
}
/**
 * Funcion que obtiene el nombre del tramo de intensidad máxima
 * @param {Array} datos Array con los datos de tramos de la query
 * @returns String con el nombre del tramo con la intensidad máxima
 */
function getTramoMaxIntensity(datos) {
  const intensidadArray = datos.map((tramo) => tramo[3]);
  const intensidadMaxima = Math.max(...intensidadArray);
  const tramo = datos.filter((element) => element[3] === intensidadMaxima);

  return tramo.flat()[2];
}
export function tramosBicis(vis, datos) {
  const nameTramoMax = getTramoMaxIntensity(datos.resultset);

  document
    .querySelector('#tabIntensidadCiclista')
    .addEventListener('click', () => {
      const data = [];
      datos.resultset.forEach((array) => {
        const idTramo = createIDTramo(array[1], array[2]);
        array.push(idTramo);
        data.push(array);
      });

      // Mostrar informacion por defecto del tramo con Maxima Intensidad
      setDOMData(
        datos.resultset.filter((element) => element[2] === nameTramoMax),
        nameTramoMax,
      );
      const objIndex = {
        id: 6,
        addres: 2,
        location: 4,
      };
      const optionsMap = {
        minZoom: 5,
        maxZoom: 20,
        initialZoom: 14,
      };
      const objMarker = {
        unselected: STYLE_MARKER,
        selected: STYLE_MARKER_SELECTED,
      };
      // Dibujar mapa
      requestAnimationFrame(() => {
        createLeafletMapPolygon(
          'mapBicis',
          objIndex,
          datos.resultset,
          objMarker,
          nameTramoMax,
          setDOMData,
          optionsMap,
          true,
        );
      });
    });
}
